import * as React from 'react';
import { IListViewColumn } from "../../../../../services/ViewService";
import { Program } from "../../../../../store/ProgramsListStore";
import { toPercentString } from "../../../../utils/common";

export default class PercentCostCompleted extends React.Component<IListViewColumn<Program>> {
    public render() {
        return <span className="font-14">
            {toPercentString(PercentCostCompleted.getValue(this.props.entity))}
        </span>;
    }

    public static getValue(entity: Program): number {
        const costs = entity.calculation.costs;
        return costs.plan !== 0 ? costs.actual / costs.plan : 0;
    }

    public static getSearchValue(entity: Program): string | undefined {
        if (!entity.calculation.costs) {
            return undefined;
        }
        return toPercentString(PercentCostCompleted.getValue(entity));
    }
}